import { computed } from 'vue';
import useMeta from './useMeta';

export default function useMetaProperties(aMetaObj) {
  const meta = aMetaObj || useMeta();
  return computed(() => meta.value?.properties || {});
}
